import { defineStore } from "pinia";
import axios from "axios";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
export const useMasterDataStore = defineStore("masterDataStore", {
  state: () => ({
    data: null,
  }),
  onInit() {
    this.get();
  },
  persist: true,
  getters: {
    filter: (state) => (id) => {
      // return "hello, iam from filtering";
      return state.data.filter((g) => g.id === id);
    },
  },

  actions: {
    async get() {
      console.log("GET MASTERDATASTORE", this.data);
      if (!this.data) {
        try {
          const config = {
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
              "content-type": "application/json",
            },
          };
          const response = await axios.post(
            `${API_BASE_URL}/get_master_data_cache`,
            {},
            config,
          ); // Replace with your API endpoint
          console.log("RESPONSE MASTERDATASTORE", response);
          this.data = response.data.data.data;
        } catch (error) {
          console.error("masterDataStore Error fetching:", error);
        }
      }
      return this.data;
    },
    // reset(){
    //     // this.data = null;
    //     // this.get();
    //     console.log("agamaStore action reset")
    //     this.$reset();  // Automatically resets the store to the initial state
    // }
    async reset() {
      console.log("RESET MASTERDATASTORE PINIA TEST");
      // Add async
      this.data = null; // Clear the store

      const newData = await this.get(); // Fetch new data

      this.data = newData; // Store the fetched data
      return this.data; // Ensure reset() returns the data
    },
  },
});
